import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import ServiceCTA from '../../components/ServiceCTA';
import RelatedServices from '../../components/RelatedServices';
import { Link } from 'react-router-dom';

const SNSService = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16" style={{ backgroundColor: '#FFF7FA' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center fade-in">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
              SNS運用サポート
            </h1>
            <p className="text-xl text-gray-700">
              InstagramやFacebookの運用をまるごとお任せ。お店の魅力を伝える投稿を代行します。
            </p>
          </div>
        </div>
      </section>

      {/* Main Content - 2 Column Layout */}
      <section className="section-spacing bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column */}
              <div className="lg:col-span-2 space-y-8">
                <div className="rounded-2xl overflow-hidden shadow-md">
                  <img 
                    src="https://images.unsplash.com/photo-1601141586963-f213d2575b7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzb2NpYWwlMjBtZWRpYSUyMHNtYXJ0cGhvbmV8ZW58MHx8fHwxNzY0NjUzNjgyfDA&ixlib=rb-4.1.0&q=85"
                    alt="SNS運用サポート"
                    className="w-full h-auto object-cover"
                  />
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    こんなことでお困りではありませんか？
                  </h2>
                  <ul className="space-y-3">
                    {[
                      'SNSを始めたいが、何を投稿していいかわからない',
                      '毎日忙しくて、SNSまで手が回らない',
                      '写真や文章が苦手で、投稿するのが大変',
                      'フォロワーが増えない、反応が少ない',
                      'SNSで新規客を増やしたい'
                    ].map((problem, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{problem}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    サービス内容
                  </h2>
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        投稿内容の企画
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        お店の魅力が伝わる投稿内容を一緒に考えます。季節のメニューやキャンペーン情報、裏側の様子など、お客様が知りたい情報をタイミングよく発信します。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        写真編集・加工
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        お店の写真を魅力的に編集・加工します。スマホで撮った写真でも、プロのような仕上がりに。必要に応じて撮影もお任せください。
                      </p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-3" style={{ color: '#2C2C2C' }}>
                        キャプション作成・ハッシュタグ選定
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        読み手の心に响く文章と、効果的なハッシュタグを選定。お店の個性を活かしながら、多くの人に見つけてもらえるよう工夫します。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-2xl p-8 shadow-sm">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスでできること
                  </h2>
                  <ul className="space-y-3">
                    {[
                      '定期的な投稿でお店の存在感をアピール',
                      '新規のお客様やフォロワーを増やす',
                      'お店のファンを作り、リピーターを増やす',
                      'キャンペーン情報をすばやく届ける',
                      'お店の雰囲気や人柄を伝える'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                  <h2 className="text-2xl font-bold mb-6" style={{ color: '#2C2C2C' }}>
                    このサービスが向いている方
                  </h2>
                  <ul className="space-y-3">
                    {[
                      'SNSを始めたいが、何を投稿していいかわからない方',
                      '毎日忙しくてSNSまで手が回らない方',
                      '写真や文章が苦手で投稿するのが大変な方',
                      'SNSで新規客を増やしたい飲食店やサロン',
                      '定期的な情報発信でお客様との繋がりを作りたい方'
                    ].map((item, index) => (
                      <li key={index} className="flex items-start">
                        <Sparkles className="w-5 h-5 mt-1 mr-3 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Column - Sidebar */}
              <div className="lg:col-span-1 space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-md border-2" style={{ borderColor: '#F7C9D3' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    料金の目安
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">ライト（月4投稿）</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>20,000円/月</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">スタンダード（月8投稿）</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>35,000円/月</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">おまかせ（月12投稿）</p>
                      <p className="text-2xl font-bold" style={{ color: '#F7C9D3' }}>50,000円～/月</p>
                    </div>
                    <Link to="/pricing" className="block text-center text-sm text-[#F7C9D3] hover:text-[#2C2C2C] font-medium mt-4">
                      詳しい料金を見る →
                    </Link>
                  </div>
                </div>

                <div className="rounded-2xl p-6 shadow-sm" style={{ backgroundColor: '#FFF7FA' }}>
                  <h3 className="text-xl font-bold mb-4" style={{ color: '#2C2C2C' }}>
                    このサービスのポイント
                  </h3>
                  <ul className="space-y-3">
                    {[
                      '投稿回数を自由に選べる',
                      '写真撮影・編集もお任せ',
                      '月１回のレポートで効果を確認'
                    ].map((point, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="w-5 h-5 mt-1 mr-2 flex-shrink-0" style={{ color: '#F7C9D3' }} />
                        <span className="text-sm text-gray-700">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                  <p className="text-sm text-gray-600 mb-4">
                    このサービスについてもっと詳しく知りたい方
                  </p>
                  <Link to="/contact" className="btn-primary block py-3 rounded-full font-medium text-sm">
                    無料相談はこちら
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedServices currentService="sns" />
      <ServiceCTA />
    </div>
  );
};

export default SNSService;